import { AsyncPipe, NgClass } from '@angular/common';
import { ChangeDetectorRef, Component, Input, OnChanges } from '@angular/core';

import { Option, OptionMarket } from '@cds/betting-offer';
import { AutomationModule } from '@frontend/sports/automation/core-feature';
import { ISimpleChanges } from '@frontend/sports/common/core/utils/simple-change';
import { CustomActiveStateDirective } from '@frontend/sports/common/ui/custom-active-state';
import { NativePrice } from '@frontend/sports/odds/feature/native-price';
import { WinGameFixture } from '@frontend/sports/racing/feature/models';
import { Store } from '@ngrx/store';
import { ExternalBetslipActions } from 'packages/sports/common/betslip/core/external-betslip-actions';
import { V2OptionMarketPickId } from 'packages/sports/common/betslip/core/picks/pick-id';
import { BetslipIntegrationService } from 'packages/sports/common/betslip/integration/betslip-integration.service';

import { GeolocationCheckService } from '../geo-location/geo-location-check.service';
import { FixtureFreeformedPricingHelper } from '../horse-racing-shared/services/fixture-freeformed-pricing-helper.service';
import { OptionIndicatorDirective } from './option-indicator.directive';
import { PickSourceProvider } from './pick-source.provider';
import { PickComponent } from './pick.component';

@Component({
    selector: 'ms-free-form-pick',
    templateUrl: 'pick.component.html',
    imports: [CustomActiveStateDirective, NgClass, OptionIndicatorDirective, AutomationModule, AsyncPipe],
})
export class FreeFormPickComponent extends PickComponent implements OnChanges {
    @Input() fixture: WinGameFixture;
    @Input() option: Option;
    @Input() optionGroup: OptionMarket;

    override pickId: V2OptionMarketPickId;

    constructor(
        geolocationCheckService: GeolocationCheckService,
        private fixtureFreeformedPricingHelper: FixtureFreeformedPricingHelper,
        private pickSourceProvider: PickSourceProvider,
        private store: Store,
        changeDetection: ChangeDetectorRef,
        betslipIntegration: BetslipIntegrationService,
    ) {
        super(geolocationCheckService, betslipIntegration, changeDetection, null);
    }

    ngOnChanges(changes: ISimpleChanges<FreeFormPickComponent>): void {
        this.state.locked = this.fixtureFreeformedPricingHelper.isPriceLocked(this.fixture, this.optionGroup, this.option, this.option.price);
        this.setPickId(this.createPickId());
    }

    get price(): NativePrice {
        return NativePrice.fromNativePrice(this.option.price);
    }

    get priceId(): number | undefined {
        return this.option.price.id;
    }

    private createPickId(): V2OptionMarketPickId {
        //TODO: Check what is free-form pick and what value should pass

        return new V2OptionMarketPickId(this.fixture.fixtureId, this.optionGroup.id, this.option.id, this.option.price.id);
    }

    protected addPick(): void {
        if (!this.state.locked) {
            const pickSource = this.pickSourceProvider.get(this.trackingSource, this.trackingPosition);
            this.store.dispatch(ExternalBetslipActions.addPick({ pickId: this.pickId, tracking: pickSource }));
        }
    }

    protected removePick(): void {
        this.store.dispatch(ExternalBetslipActions.removePick({ pickId: this.pickId }));
    }
}
